import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function UrgencyBar() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 w-full z-[60] bg-[#c9a55a] text-[#0d0d0d]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 flex-1 justify-center flex-wrap">
          <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
            <i className="ri-time-line text-[#0d0d0d] text-sm" />
          </div>
          <span className="text-xs md:text-sm font-bold whitespace-nowrap">
            Limited slots available this month —
          </span>
          <span className="text-xs md:text-sm font-medium whitespace-nowrap">
            We respond within 2 hours.
          </span>
          <Link
            to="/contact"
            className="ml-2 bg-[#0d0d0d] text-[#c9a55a] text-xs font-black px-3 py-1 rounded-full hover:bg-[#1c1a17] transition-colors whitespace-nowrap cursor-pointer"
          >
            Book Now →
          </Link>
        </div>
        <button
          type="button"
          onClick={() => setVisible(false)}
          className="w-6 h-6 flex items-center justify-center flex-shrink-0 hover:opacity-70 transition-opacity cursor-pointer"
          aria-label="Close"
        >
          <i className="ri-close-line text-[#0d0d0d] text-base" />
        </button>
      </div>
    </div>
  );
}
